import { useGetInteractionsDictionaryQuery } from 'src/api/interactions-dictionary';
import { PageLoader } from 'src/components/PageLoader';
import { PageTitle } from 'src/components/PageTitle';
import { InteractionDictionaryList } from 'src/features/interaction-dictionary/feature-interaction-dictionary-list/components';

import styles from './styles.module.css';

export const InteractionDictionary = () => {
  const { data, isPending } = useGetInteractionsDictionaryQuery();

  if (isPending) {
    return <PageLoader visible={true} />;
  }

  const interactions =
    data?.map((interaction) => ({
      description: interaction.description,
      id: interaction.id,
      imageSrc: interaction.poster,
      name: interaction.name,
    })) || [];

  return (
    <div className={styles.interactionsRepository}>
      <PageTitle title="Interactions Repository" />
      <InteractionDictionaryList interactions={interactions} />
    </div>
  );
};
